const AGENT_TONE_DRAFT_KEY = "agentToneDraftV1";
const AGENT_TONE_HISTORY_KEY = "agentToneHistoryV1";
const MAX_HISTORY_ITEMS = 100;

function readJson(key, fallback) {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // no-op: storage can fail in private mode/quota
  }
}

export function loadAgentToneDraft() {
  return readJson(AGENT_TONE_DRAFT_KEY, null);
}

export function saveAgentToneDraft(draft) {
  writeJson(AGENT_TONE_DRAFT_KEY, draft);
}

export function getAgentToneHistory() {
  return readJson(AGENT_TONE_HISTORY_KEY, []);
}

export function appendAgentToneHistory(record) {
  const current = getAgentToneHistory();
  const next = [record, ...current].slice(0, MAX_HISTORY_ITEMS);
  writeJson(AGENT_TONE_HISTORY_KEY, next);
  return next;
}
